import React from 'react';

import { MdModeEdit, MdDelete, MdCheck } from 'react-icons/md';

import history from '~/services/history';

const columnSepse = () => {
  const editarLinha = (id, data) => {
    history.push({
      pathname: `/formulario-linhas-de-cuidado/${data.linhaDeCuidadoValue}`,
      state: {
        periodo: data.periodoSelecionado,
        indicador: data.linhaDeCuidadoValue,
        indicadorNome: data.linhaDeCuidado,
        idRecord: Number(id),
        id: Number(id),
      },
    });
  };

  const deletarLinha = (id, data) => {
    history.push({
      pathname: `/linha-de-cuidado/${data.linhaDeCuidadoValue}`,
      state: {
        periodo: data.periodoSelecionado,
        indicador: data.linhaDeCuidadoValue,
        indicadorNome: data.linhaDeCuidado,
        deleteLinha: Number(id),
      },
    });
  };

  return [
    {
      title: 'Número do registro',
      dataIndex: 'num_registro_sepse',
      key: 'num_registro_sepse',
      width: 170,
      sorter: (a, b) => a.num_registro_sepse - b.num_registro_sepse,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Identificador do paciente',
      dataIndex: 'identificadordoPaciente',
      key: 'identificadordoPaciente',
      width: 210,
    },

    {
      title: 'Completo',
      key: 'completo',
      dataIndex: 'completo',
      width: 120,
      sorter: (a, b) => a.completo - b.completo,
      sortDirections: ['descend', 'ascend'],
      render: (id, data) => {
        return (
          <div>{data.completo && <MdCheck size={20} color="#74a50a" />}</div>
        );
      },
    },
    {
      title: '',
      key: 'id',
      dataIndex: 'id',
      width: 210,
      render: (id, data) => {
        return (
          <div className="botoesGrid">
            <button type="button" onClick={() => editarLinha(id, data)}>
              <MdModeEdit size={18} />
              Editar
            </button>
            <button
              type="button"
              className="btn-remove"
              onClick={() => deletarLinha(id, data)}
            >
              <MdDelete size={18} />
              Excluir
            </button>
          </div>
        );
      },
    },

    {
      title: 'Sexo',
      dataIndex: 'sexo_sepse_descritivo',
      key: 'sexo_sepse',
      width: 100,
    },

    {
      title: 'Data de nascimento',
      dataIndex: 'dn_sepse',
      key: 'dn_sepse',
      width: 110,
    },

    {
      title: 'Convênio do paciente',
      dataIndex: 'convenio_sepse_descritivo',
      key: 'convenio_sepse',
      width: 130,
    },

    {
      title: 'Imunossupressão',
      dataIndex: 'imuno_sepse_descritivo',
      key: 'imuno_sepse',
      width: 150,
    },

    {
      title: 'Neoplasia ativa',
      dataIndex: 'neoplasia_sepse_descritivo',
      key: 'neoplasia_sepse',
      width: 100,
    },

    {
      title: 'Acidente vascular cerebral',
      dataIndex: 'avc_sepse_descritivo',
      key: 'avc_sepse',
      width: 100,
    },

    {
      title: 'Cirrose',
      dataIndex: 'cirrose_sepse_descritivo',
      key: 'cirrose_sepse',
      width: 100,
    },

    {
      title: 'Doença renal crônica',
      dataIndex: 'drc_sepse_descritivo',
      key: 'drc_sepse',
      width: 150,
    },

    {
      title: 'Diabetes',
      dataIndex: 'dm_sepse_descritivo',
      key: 'dm_sepse',
      width: 100,
    },

    {
      title: 'Tipo de infecção',
      dataIndex: 'infeccao_sepse_descritivo',
      key: 'infeccao_sepse',
      width: 150,
    },

    {
      title: 'Gravidade da apresentação clínica',
      dataIndex: 'apre_clinica_sepse_descritivo',
      key: 'apre_clinica_sepse',
      width: 180,
    },

    {
      title: 'Data do início dos sintomas de disfunção orgânica',
      dataIndex: 'sintomas_data_sepse',
      key: 'sintomas_data_sepse',
      width: 200,
    },

    {
      title: 'Hora do início dos sintomas de disfunção orgânica',
      dataIndex: 'sintomas_hora_sepse',
      key: 'sintomas_hora_sepse',
      width: 200,
    },

    {
      title: 'Sobre a data e hora do início dos sintomas de disfunção orgânica',
      dataIndex: 'sintomas_local_sepse_descritivo',
      key: 'sintomas_local_sepse',
      width: 220,
    },

    {
      title: 'Data da impressão diagnóstica de sepse ou choque séptico',
      dataIndex: 'diagnostico_data_sepse',
      key: 'diagnostico_data_sepse',
      width: 220,
    },

    {
      title: 'Hora da impressão diagnóstica de sepse ou choque séptico',
      dataIndex: 'diagnostico_hora_sepse',
      key: 'diagnostico_hora_sepse',
      width: 200,
    },

    {
      title:
        'Pressão arterial sistólica logo após a suspeita de sepse ou choque séptico',
      dataIndex: 'pas_diagnostico_sepse',
      key: 'pas_diagnostico_sepse',
      width: 220,
    },

    {
      title:
        'Pressão arterial diastólica logo após a suspeita de sepse ou choque séptico',
      dataIndex: 'pad_diagnostico_sepse',
      key: 'pad_diagnostico_sepse',
      width: 230,
    },

    {
      title: 'Data da 1ª coleta de lactato sérico',
      dataIndex: 'lactato1_data_sepse',
      key: 'lactato1_data_sepse',
      width: 140,
    },

    {
      title: 'Hora da 1ª coleta de lactato sérico',
      dataIndex: 'lactato1_hora_sepse',
      key: 'lactato1_hora_sepse',
      width: 140,
    },
    {
      title: 'Resultado da 1ª coleta de lactato sérico',
      dataIndex: 'lactato1_resultado_sepse',
      key: 'lactato1_resultado_sepse',
      width: 140,
    },
    {
      title: 'Unidade de medida da 1ª coleta de lactato sérico',
      dataIndex: 'lactato1_unidade_sepse_descritivo',
      key: 'lactato1_unidade_sepse',
      width: 150,
    },
    {
      title: 'Data da 2ª coleta de lactato sérico',
      dataIndex: 'lactato2_data_sepse',
      key: 'lactato2_data_sepse',
      width: 140,
    },
    {
      title: 'Hora da 2ª coleta de lactato sérico',
      dataIndex: 'lactato2_hora_sepse',
      key: 'lactato2_hora_sepse',
      width: 140,
    },
    {
      title: 'Resultado da 2ª coleta de lactato sérico',
      dataIndex: 'lactato2_resultado_sepse',
      key: 'lactato2_resultado_sepse',
      width: 130,
    },
    {
      title: 'Unidade de medida da 2ª coleta de lactato sérico',
      dataIndex: 'lactato2_unidade_sepse_descritivo',
      key: 'lactato2_unidade_sepse',
      width: 150,
    },
    {
      title: 'Data da 1ª coleta de hemocultura',
      dataIndex: 'hemocultura_data_sepse',
      key: 'hemocultura_data_sepse',
      width: 130,
    },
    {
      title: 'Hora da 1ª coleta de hemocultura',
      dataIndex: 'hemocultura_hora_sepse',
      key: 'hemocultura_hora_sepse',
      width: 130,
    },
    {
      title:
        'Pacientes em uso de antimicrobianos no momento da impressão diagnóstica de sepse ou choque séptico',
      dataIndex: 'antimicrobiano_previo_sepse_descritivo',
      key: 'antimicrobiano_previo_sepse',
      width: 250,
    },
    {
      title:
        'Data da 1ª dose de antimicrobiano após a suspeita de sepse ou choque séptico',
      dataIndex: 'antimicrobiano_data_sepse',
      key: 'antimicrobiano_data_sepse',
      width: 200,
    },
    {
      title:
        'Hora da 1ª dose de antimicrobiano após a suspeita de sepse ou choque séptico',
      dataIndex: 'antimicrobiano_hora_sepse',
      key: 'antimicrobiano_hora_sepse',
      width: 200,
    },
    {
      title: 'Paciente recebeu reposição volêmica adequada',
      dataIndex: 'rep_vol_realizacao_sepse_descritivo',
      key: 'rep_vol_realizacao_sepse',
      width: 160,
    },
    {
      title: 'Data do início da reposição volêmica',
      dataIndex: 'rep_vol_data_sepse',
      key: 'rep_vol_data_sepse',
      width: 130,
    },
    {
      title: 'Hora do início da reposição volêmica',
      dataIndex: 'rep_vol_hora_sepse',
      key: 'rep_vol_hora_sepse',
      width: 130,
    },
    {
      title:
        'Pressão arterial sistólica imediatamente após a infusão de solução para reposição volêmica',
      dataIndex: 'pas_infusao_sepse',
      key: 'pas_infusao_sepse',
      width: 200,
    },
    {
      title:
        'Pressão arterial diastólica imediatamente após a infusão de solução para reposição volêmica',
      dataIndex: 'pad_infusao_sepse',
      key: 'pad_infusao_sepse',
      width: 200,
    },
    {
      title: 'Data da medida da pressão arterial após a reposição volêmica',
      dataIndex: 'pa_infusao_data_sepse',
      key: 'pa_infusao_data_sepse',
      width: 180,
    },
    {
      title: 'Hora da medida da pressão arterial após a reposição volêmica',
      dataIndex: 'pa_infusao_hora_sepse',
      key: 'pa_infusao_hora_sepse',
      width: 160,
    },
    {
      title: 'Paciente recebeu vasopressores',
      dataIndex: 'vasop_realizacao_sepse_descritivo',
      key: 'vasop_realizacao_sepse',
      width: 120,
    },
    {
      title: 'Data do início da infusão do vasopressor',
      dataIndex: 'vasop_data_sepse',
      key: 'vasop_data_sepse',
      width: 120,
    },

    {
      title: 'Hora do início da infusão do vasopressor',
      dataIndex: 'vasop_hora_sepse',
      key: 'vasop_hora_sepse',
      width: 120,
    },

    {
      title: 'Data da revisão da terapia antimicrobiana',
      dataIndex: 'revisao_data_sepse',
      key: 'revisao_data_sepse',
      width: 150,
    },

    {
      title: 'Hora da revisão da terapia antimicrobiana',
      dataIndex: 'revisao_hora_sepse',
      key: 'revisao_hora_sepse',
      width: 170,
    },

    {
      title: 'Paciente em medidas de conforto ou cuidados paliativos',
      dataIndex: 'paliativos_sepse_descritivo',
      key: 'paliativos_sepse',
      width: 170,
    },

    {
      title: 'Paciente teve diagnóstico de COVID-19 durante a internação',
      dataIndex: 'covid_sepse',
      key: 'covid_sepse',
      width: 210,
    }, //

    {
      title: 'Motivo da saída hospitalar',
      dataIndex: 'saida_motivo_sepse_descritivo',
      key: 'saida_motivo_sepse',
      width: 120,
    },

    {
      title: 'Data da saída',
      dataIndex: 'saida_data_sepse',
      key: 'saida_data_sepse',
      width: 110,
    },
    {
      title: 'Hora da saída',
      dataIndex: 'saida_hora_sepse',
      key: 'saida_hora_sepse',
      width: 110,
    },
  ];
};

export default columnSepse;
